export default __webpack_public_path__ + "static/blob8-fcfdd2727f97d01d12a9df7eee6a3e2a.svg";